module.exports = "<div class=\"category-badge common-category\" [ngClass]=\"categoryClass\">\r\n    {{ readableCategoryNameUpperCase }}\r\n</div>"